import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Symbols from '../../../common/assets/symbols'

export default class extends Component {
  constructor(props) {
    super(props)

    this.state = {
      height: '0',
      show: false,
    }

    this.sections = React.createRef()

    this.show = this.show.bind(this)
    this.hide = this.hide.bind(this)
  }

  show() {
    this.setState({
      show: true,
    })
  }

  hide() {
    this.setState({
      show: false,
    })
  }

  componentDidMount() {
    const sections = this.sections.current
    const height = sections.offsetHeight

    this.setState({
      height: `${height}px`,
    })
  }

  render() {
    const styles = {
      dropdown: {
        height: this.state.show ? this.state.height : '0',
      },
      sections: {
        transform: this.state.show ? `translate3d(0,0,0)` : `translate3d(0,-100%,0)`,
      },
    }

    return (
      <div className="menu" onMouseEnter={this.show} onMouseLeave={this.hide}>
        <Link to="/browse" className="menu__button">
          <span className="menu__text">Watch</span>
          <span className="menu__icon">{Symbols.down}</span>
        </Link>
        <div className="menu__dropdown" style={styles.dropdown}>
          <div className="menu__sections" ref={this.sections} style={styles.sections}>
            <div className="menu__section">
              <ul className="menu__list menu__list--primary">
                <li className="menu__item">
                  <Link className="menu__link" to="/browse">Home</Link>
                </li>
                {/* <li className="menu__item">
                  <Link className="menu__link" to="/browse/genre/my-list">My List</Link>
                </li> */}
                <li className="menu__item">
                  <Link className="menu__link" to="/browse/genre/recently-added">Recently Added</Link>
                </li>
                <li className="menu__item">
                  <Link className="menu__link" to="/browse/genre/latest-videos">Latest Videos</Link>
                </li>
              </ul>
            </div>
            <div className="menu__section">
              <ul className="menu__list menu__list--secondary">
                <li className="menu__item">
                  <Link className="menu__link" to="/browse/genre/full-length-videos">Full-Length Videos</Link>
                </li>
                <li className="menu__item">
                  <Link className="menu__link" to="/browse/genre/parts">Parts</Link>
                </li>
                <li className="menu__item">
                  <Link className="menu__link" to="/browse/genre/contests">Contests</Link>
                </li>
                <li className="menu__item">
                  <Link className="menu__link" to="/browse/genre/documentaries">Documentaries</Link>
                </li>
                <li className="menu__item">
                  <Link className="menu__link" to="/browse/genre/shop-and-homie-videos">Shop & Homie Videos</Link>
                </li>
                <li className="menu__item">
                  <Link className="menu__link" to="/browse/genre/tours">Tours</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/desktop/components/menu/index.js